export enum LegendClickEvent {
    uncolorAll = "uncolorAll",  // Normocinesia tutti
    uncolorSelected = "uncolorSelected",  // Normocinesia su mappa selezionata
    colorAll = "colorAll",  // Colore tutti
    colorSelected = "colorSelected", // Colore su mappa selzionata
}
